import Forschungsprojekt from './Forschungsprojekt'
import ForschungsprojektFilter from './ForschungsprojektFilter'
import Publikation from './Publikation'
import PublikationFilter from './PublikationFilter'
import Preis from './Preis'
import PreisFilter from './PreisFilter'
import Organisationseinheit from './Organisationseinheit'
import OrganisationseinheitFilter from './OrganisationseinheitFilter'
import Person from './Person'
import PersonFilter from './PersonFilter'
import AbstractPerson from './AbstractPerson'
import AbstractPersonFilter from './AbstractPersonFilter'
import ExterneOrganisation from './ExterneOrganisation'
import ExterneOrganisationFilter from './ExterneOrganisationFilter'
import Kooperation from './Kooperation'
import KooperationFilter from './KooperationFilter'
import Veranstaltung from './Veranstaltung'
import VeranstaltungFilter from './VeranstaltungFilter'
import Patent from './Patent'
import PatentFilter from './PatentFilter'
import Land from './Land'
import LandFilter from './LandFilter'
import AppUser from './AppUser'
import AppUserFilter from './AppUserFilter'
import Mittelgeber from './Mittelgeber'
import MittelgeberFilter from './MittelgeberFilter'

export const ListSchema = {
  forschungsprojekt: Forschungsprojekt,
  externeorganisation: ExterneOrganisation,
  kooperation: Kooperation,
  publikation: Publikation,
  preis: Preis,
  person: Person,
  organisationseinheit: Organisationseinheit,
  abstractperson: AbstractPerson,
  veranstaltung: Veranstaltung,
  patent: Patent,
  land: Land,
  appuser: AppUser,
  mittelgeber: Mittelgeber
}

export const FilterSchema = {
  forschungsprojekt: ForschungsprojektFilter,
  externeorganisation: ExterneOrganisationFilter,
  kooperation: KooperationFilter,
  publikation: PublikationFilter,
  preis: PreisFilter,
  person: PersonFilter,
  organisationseinheit: OrganisationseinheitFilter,
  abstractperson: AbstractPersonFilter,
  veranstaltung: VeranstaltungFilter,
  patent: PatentFilter,
  land: LandFilter,
  appuser: AppUserFilter,
  mittelgeber: MittelgeberFilter
}



// WEBPACK FOOTER //
// ./src/schema/list/index.js